import React, { useState } from 'react';
import { API_URL } from '../../../settings/local_settings';
import { LocalStorage } from '../../../utils/LocalStorage';

export function BlockIssueForm({ reportId, block, onClose }) {
    const [description, setDescription] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async () => {
        if (!description.trim()) return;
        setSending(true);
        try {
            const token = LocalStorage.fetchUserToken();
            await fetch(`${API_URL}reports/${reportId}/issues/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                },
                body: JSON.stringify({
                    description: description.trim(),
                    block_id: block.id,
                    block_title: block.title || null,
                    block_type: block.type,
                    block_data: block.data || null,
                    query_params: block.query_params || null,
                    ai_insight: block.ai_insight || null
                })
            });
            setSent(true);
            setTimeout(() => {
                onClose();
            }, 2500);
        } catch (err) {
            // silently fail — endpoint may not exist yet
        } finally {
            setSending(false);
        }
    };

    if (sent) {
        return (
            <div className="block-issue-form block-issue-form--sent">
                <i className="fa fa-check-circle"></i>
                <span>Problema reportado</span>
            </div>
        );
    }

    return (
        <div className="block-issue-form">
            <p className="block-issue-form__hint">
                Describe el problema que encontraste en este bloque (datos incorrectos, metricas faltantes, formato, etc.)
            </p>
            <textarea
                className="block-issue-form__textarea"
                placeholder="Ej: el grafico muestra datos del mes anterior en vez del actual..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                maxLength={2000}
                rows={3}
                autoFocus
            />
            <div className="block-issue-form__actions">
                <button
                    className="block-issue-form__cancel"
                    onClick={onClose}
                    disabled={sending}
                >
                    Cancelar
                </button>
                <button
                    className="block-issue-form__submit"
                    onClick={handleSubmit}
                    disabled={sending || !description.trim()}
                >
                    {sending ? 'Enviando...' : 'Reportar problema'}
                </button>
            </div>
        </div>
    );
}
